import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSelectorUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M12.108 29.728h23.784L24 19.272z" }) }) })
});
export default SvgSelectorUp;
